<div @list class="aw-toast-container">
  @for (message of toast.getMessages() | async; track trackBy($index, message)) {
    <div class="aw-toast-message" @items>
      <div class="aw-toast-title"
             [ngClass]="{
          'warning': message.messageType===ToastMessageType.warning,
          'error': message.messageType===ToastMessageType.error,
          'success': message.messageType===ToastMessageType.success
        }" >
        <h1>{{message.title}}</h1>
        <div class="aw-close-icon" (click)="toast.dismissMessage(message.uniqueId, 'Closed')">
          <div style="width: 24px;height:24px;">
            <svg class="svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="none" d="M0 0h24v24H0V0z"/>
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="aw-toast-content">
        @if (message.showLoader) {
          <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
        }
        @if (message.content) {
          <p>
            {{message.content}}
          </p>
        }
        @if (message.multiLineContent) {
          <ul>
            @for (cont of message.multiLineContent; track cont) {
              <li><span class="symbol">{{cont.symbol}}</span><span class="name">{{cont.description}}</span></li>
            }
          </ul>
        }
      </div>
      <div>
        @switch (message.buttons) {
          @case (Buttons.YesNo) {
            <div class="aw-toast-buttons" >
              <button class="aw-button" (click)="toast.relayMessage(message.uniqueId, responses.No)">No</button>
              <button class="aw-button default" (click)="toast.relayMessage(message.uniqueId, responses.Yes)">Yes</button>
            </div>
          }
          @case (Buttons.OkCancel) {
            <div class="aw-toast-buttons" >
              <button class="aw-button" (click)="toast.relayMessage(message.uniqueId, responses.Cancel)">Cancel</button>
              <button class="aw-button default" (click)="toast.relayMessage(message.uniqueId, responses.Ok)">OK</button>
            </div>
          }
          @case (Buttons.Ok) {
            <div class="aw-toast-buttons" >
              <button class="aw-button default" (click)="toast.relayMessage(message.uniqueId, responses.Ok)">OK</button>
            </div>
          }
        }
      </div>
    </div>
  }
</div>